import angular from 'angular';

import './store';
import './new-connect';

angular.module('app.old-connect', ['app.connnect.store']);
